export default "__VITE_ASSET__ed640df2__"